import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant32() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      title1: 'Сделаем сайт для вас ',
      titleFree: 'бесплатно.',
      title2: `Обслуживание — ${price}/мес.`,
      subHtml: `Мы делаем сайт <strong>за свой счёт</strong>. Вы смотрите, просите правки, утверждаете. Когда всё нравится — <strong>платите ${price} в месяц</strong> за хостинг и поддержку. Не понравится — просто уходите. <strong>Без оплаты.</strong>`,
      cta: 'Оставить заявку'
    },
    ua: {
      title1: 'Зробимо сайт для вас ',
      titleFree: 'безкоштовно.',
      title2: `Обслуговування — ${price}/міс.`,
      subHtml: `Ми робимо сайт <strong>за свій рахунок</strong>. Ви дивитеся, просите правки, затверджуєте. Коли все подобається — <strong>платите ${price} на місяць</strong> за хостинг та підтримку. Не сподобається — просто йдете. <strong>Без оплати.</strong>`,
      cta: 'Залишити заявку'
    },
    en: {
      title1: 'We build your website ',
      titleFree: 'for free.',
      title2: `Maintenance — ${price}/mo.`,
      subHtml: `We build the site <strong>at our expense</strong>. You review, request edits, and approve. When you love it, you <strong>pay ${price}/month</strong> for hosting and support. Don't like it? Just walk away. <strong>No charge.</strong>`,
      cta: 'Submit request'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-624">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12 px-4" data-id="element-625">
          {/* Left Column - Typography & Marker */}
          <div className="w-full lg:w-1/2 text-left flex flex-col items-start" data-id="element-626">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="mb-8 text-4xl md:text-5xl lg:text-[3.5rem] font-black leading-[1.2] tracking-tight text-gray-900" data-id="element-627">
              {content.title1}
              <span className="relative inline-block whitespace-nowrap" data-id="element-628">
                <span className="relative z-10" data-id="element-629">{content.titleFree}</span>
                <motion.div initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                delay: 0.5,
                duration: 0.6
              }} className="absolute bottom-2 left-0 w-full h-5 bg-yellow-300/60 -rotate-2 origin-left" data-id="element-630" />
              </span>
              <br data-id="element-631" />
              <span className="text-gray-500" data-id="element-632">{content.title2}</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-lg md:text-xl mb-10 text-gray-600 leading-relaxed max-w-lg" dangerouslySetInnerHTML={{
            __html: content.subHtml
          }} data-id="element-633" />

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} data-id="element-634">
              <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-xl px-8 py-4 font-bold text-lg transition-all hover:scale-105" style={{
              backgroundColor: 'var(--accent)',
              color: '#FFFFFF'
            }} data-id="element-635">
                {content.cta}
                <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-636" />
              </button>
            </motion.div>
          </div>

          {/* Right Column - Clean Video */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative mt-12 lg:mt-0" data-id="element-637">
            <div className="relative w-full max-w-2xl mx-auto rounded-3xl overflow-hidden shadow-2xl border border-gray-100" data-id="element-638">
              <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-639" />
            </div>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-640" />
    </>;
}